'use strict';

const calendarMonthTokens = (theme) => ({
    calendarMonthNavIconPaddingX: theme.space.component.x.m,
    calendarMonthWeekdayColor: theme.colors.body.text,
    calendarMonthWeekdayFontFamily: theme.typography.fontFamily.regular,
    calendarMonthWeekdayFontSize: theme.typography.fontSize.s,
    calendarMonthWeekdayFontWeight: theme.typography.fontWeight.bold,
    calendarMonthWeekdayLineHeight: theme.typography.lineHeight.m,
    calendarMonthWeekdayTextAlign: 'center',
    calendarMonthDayBackgroundColor: 'transparent',
    calendarMonthDayFontSize: theme.typography.fontSize.s,
    calendarMonthDayColor: theme.colors.body.text,
    calendarMonthDayTextAlign: 'center',
    calendarMonthDayLineHeight: theme.typography.lineHeight.m,
    calendarMonthDayFontFamily: theme.typography.fontFamily.regular,
    calendarMonthDayFontWeight: theme.typography.fontWeight.semibold,
    calendarMonthDayRadius: theme.radiuses.xl,
    calendarMonthDayDisabledColor: theme.colors.disabled.text,
    calendarMonthDayHoverBackgroundColor: theme.colors.primary.alpha,
    calendarMonthDayFocusBackgroundColor: theme.colors.primary.normal,
    calendarMonthDayFocusTextColor: theme.colors.body.textLight,
});

exports.calendarMonthTokens = calendarMonthTokens;
//# sourceMappingURL=calendarMonth.js.map
